import { SxProps, Theme } from "@mui/material";
import { BUTTON_HEIGHT } from "./buttonHeight";

// Makes a ToggleButtonGroup read like the segmented clarity selector used on the pricing pages: each
// option is a blue outline, and the active one is filled solid blue with white text.
//
// It also pins the group to a Button's height. MUI pads a ToggleButton more generously than a
// Button, so an untouched group stands taller than everything beside it and a row of controls comes
// out ragged. The vertical padding is dropped and the height set outright, per size.
export const toggleSelectorSx: SxProps<Theme> = {
  "& .MuiToggleButton-root": {
    height: BUTTON_HEIGHT.medium,
    paddingTop: 0,
    paddingBottom: 0,
    color: "primary.main",
    borderColor: "primary.main",
    "&.Mui-selected": {
      bgcolor: "primary.main",
      color: "common.white",
      "&:hover": { bgcolor: "primary.dark" },
    },
  },
  // After the rule above, so the size the group actually uses wins.
  "& .MuiToggleButton-sizeSmall": { height: BUTTON_HEIGHT.small },
  "& .MuiToggleButton-sizeLarge": { height: BUTTON_HEIGHT.large },
};
